import React, { ComponentType, lazy, ReactElement } from 'react'
import { Navigate, NavLinkProps, Route, Routes } from 'react-router'
import { UserRoles } from '@src/types/user'
import { useProfile } from '@store/app'
import NotFoundPage from '@pages/NotFound'
import LoginPage from '@pages/Login'
import NotificationNavLink from '@components/Layout/Sidebar/NotificationNavLink'

type IRoute = {
  path: string;
  title: string;
  element: React.LazyExoticComponent<ComponentType<any>> | (() => ReactElement);
  roles?: UserRoles[];
  hidden?: boolean;
  navLink?: ComponentType<NavLinkProps>;
}

export const routes: IRoute[] = [
  {
    path: '/statistics',
    element: lazy(() => import('@pages/Statistics')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Статистика'
  },
  {
    path: '/dealers',
    element: lazy(() => import('@pages/Dealers')),
    roles: [ UserRoles.ADMIN ],
    title: 'Дилеры'
  },
  {
    path: '/leads',
    element: lazy(() => import('@pages/Leads')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Лиды'
  },
  {
    path: '/notifications',
    element: lazy(() => import('@pages/Notifications')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Уведомления',
    navLink: NotificationNavLink
  },
  {
    path: '/settings',
    element: lazy(() => import('@pages/Settings')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Настройки'
  },
  {
    path: '/notes',
    element: lazy(() => import('@pages/Notes')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Памятка'
  },
  {
    path: '/notes/:id',
    element: lazy(() => import('@pages/Note')),
    roles: [ UserRoles.ADMIN, UserRoles.DEALER ],
    title: 'Памятка',
    hidden: true
  },
  {
    path: '*',
    element: NotFoundPage,
    title: 'NotFound',
    hidden: true
  }
]

export function useRoutes() {
  const profile = useProfile()

  if (!profile) {
    return []
  }

  return routes.filter(({ roles }) => (
    !roles || !roles.length || roles.includes(profile!.role)
  ))
}

const AppRoutes = () => {
  const routes = useRoutes()

  return (
    <Routes>
      {routes.length > 0 && (
        <Route index path='/' element={<Navigate to={routes[0].path} />} />
      )}
      {routes.map(({ path, element: Element }: IRoute) => (
        <Route key={path} path={path} element={<Element />} />
      ))}
      <Route path="/login" element={<LoginPage />} />
    </Routes>
  )
}

export default AppRoutes